import { Platform, Linking } from 'react-native';

export default class LinkHandler {
  setupInitialLinkHandler(callback: any) {
    this.callback = callback;

    Linking.getInitialURL()
      .then((url) => this.onInitialUrlReady(url));
  }

  setupListener(callback: any) {
    console.log('[Notifications:LinkHandler] getInitialURL');
    Linking.getInitialURL()
      .then((url) => this.onInitialUrlReady(url));
    this.callback = callback;
    
    console.log('[Notifications:LinkHandler] setupListener');
    Linking.addEventListener('url', this.onInitialUrlEvent);
  }

  cleanup() {
    this.callback = undefined;
    Linking.removeEventListener('url', this.onInitialUrlEvent);
  }

  onInitialUrlEvent = (e) => {
    console.log('[Notifications:LinkHandler] initial url event', e);
    this.onInitialUrlReady(e.url);
  }

  onInitialUrlReady = (url: string) => {
    console.log('[Notifications:LinkHandler] initial url ready', url);
    let parsed = this.parseNotificationUrl(url);
    if (this.callback) {
      this.callback(url, parsed);
    }
  }

  parseNotificationUrl(url: string) : any|undefined {
    if (!url) {
      console.log('[Notifications:LinkHandler] no navigation url found');
      return undefined;
    }

    // todo: remove more old hosts from handling here
    const hosts = "^(https://app.fitbeat.com/|https://app.fitillion.com/|https://app-staging.fitillion.com/|fitbeat://)";

    const localhostMatch = url.match('^http://localhost:[0-9]+/(.*)$');
    if (localhostMatch) {
      const rewriteUrl = 'fitbeat://' + localhostMatch[1];
      console.log('[Notifications:LinkHandler] localhost, rewriting to custom scheme url', rewriteUrl);
      return this.parseNotificationUrl(rewriteUrl);
    }

    const webMatch = url.match(hosts + "/(.*)$");
    if (webMatch) {
      const rewriteUrl = webMatch[1] + webMatch[2];
      console.log('[Notifications:LinkHandler] url, rewriting', rewriteUrl);
      return this.parseNotificationUrl(rewriteUrl);
    }

    const re = hosts + "notifications/([a-f0-9]+)$";
    const notificationMatch = url.match(re);
    if (notificationMatch) {
      const prefix = notificationMatch[1];
      const id = notificationMatch[2];
      console.log('[Notifications:LinkHandler] notification url found with id', prefix, id);
      return {
        id,
        type: 'notification',
      };
    }

    const reSubscription = hosts + "subscriptions$";
    const subscriptionMatch = url.match(reSubscription);
    if (subscriptionMatch) {
      const prefix = subscriptionMatch[1];
      console.log('[Subscriptions:LinkHandler] subscription url found', prefix);
      return {
        type: 'subscription',
      };
    }

    console.warn('[Notifications:LinkHandler] not a notification url', url);
    return undefined;
  }
}
